class LocalStorageService {
  public get<TData>(itemName: string): TData | undefined {
    const item = localStorage.getItem(itemName);

    return item ? JSON.parse(item) : undefined;
  }

  public set<TData>(itemName: string, item: TData) {
    localStorage.setItem(itemName, JSON.stringify(item));
  }

  public remove(itemName: string) {
    localStorage.removeItem(itemName);
  }
}

export default new LocalStorageService();
